import {FieldLadingExcel} from "@/enums/fieldladingexcel";
import {FieldReceiptPartnerExcel} from "@/enums/fieldreceiptpartnerexcel";
import {FieldUpdateCostBillLadingExcel} from "@/enums/fieldupdatecostbillLadingexcel";
import {FieldReportDeliveryExcel} from "@/enums/fieldreportdeliveryexcel";

export const ACCESS_TOKEN = "sdjfhsdgwjfker123123nvmcnmvn123";
export const MOBILE_PHONE_REGEX = /(09[0|1|2|3|4|5|6|7|8|9]|03[2|3|4|5|6|7|8|9]|05[6|8|9]|07[0|6|7|8|9]|08[1|2|3|4|5|6|8|9])+([0-9]{7})\b/g;
export const PHONE_REGEX = /^(0[0-9]{9})$/g;
export const API_GOOGLE_AUTOCOMPLETE = "https://maps.googleapis.com/maps/api/place/autocomplete/json";
export const API_GOOGLE_PLACE_DETAIL = "https://maps.googleapis.com/maps/api/place/details/json";
export const GOOGLE_APT_KEY = "AIzaSyCHddIuaZitAyZu4L7imJaxhG227YYdq_8";
export const FORMAT_DATE_PICKER = "DD/MM/YYYY";
export const FORMAT_DATE_TIME_PICKER = "HH:mm DD/MM/YYYY";
export const MAPPING_LADING_EXCEL = {
    'van_don': FieldLadingExcel.LadingCode,
    'ma_don_hang': FieldLadingExcel.OrderCode,
    'dai_dien_gui': FieldLadingExcel.Username,
    'sdt_gui': FieldLadingExcel.LocationFromPhoneNumber,
    'sdt_nhan': FieldLadingExcel.LocationToPhoneNumber,
    'nguoi_nhan': FieldLadingExcel.LocationToName,
    'dia_chi': FieldLadingExcel.LocationToAddress,
    'ma_tinh': FieldLadingExcel.LocationToProvince,
    'phuong_xa': FieldLadingExcel.LocationToDistrict,
    // 'phuong_xa': FieldLadingExcel.LocationToWard,
    'nd_hang': FieldLadingExcel.BoxContent,
    'so_kien': FieldLadingExcel.BoxQuantity,
    'gia_tri': FieldLadingExcel.BoxPrice,
    'thu_ho(cod)': FieldLadingExcel.CodMoney,
    'kl': FieldLadingExcel.Weight,
    'ma_dv': FieldLadingExcel.FreightService,
    'ma_dv_gtgt': FieldLadingExcel.FreightServiceAdds,
    'hinh_thuc_tt': FieldLadingExcel.Payment,
    // 'cuoc_cong_them': FieldLadingExcel.FeeExtra,
    'ghi_chu_giao_hang': FieldLadingExcel.Note,
};

export const MAPPING_RECEIPT_PARTNER_EXCEL = {
    'Mã vận đơn': FieldReceiptPartnerExcel.LadingCode
}

export const MAPPING_UPDATE_COST_BILL_LADING_EXCEL = {
    'Mã vận đơn': FieldUpdateCostBillLadingExcel.LadingCode,
    'Số tiền': FieldUpdateCostBillLadingExcel.Money
}

export const MAPPING_CREATE_REPORT_DELIVERY_EXCEL = {
    'Mã vận đơn': FieldReportDeliveryExcel.LadingCode,
    'Người nhận': FieldReportDeliveryExcel.Receiver,
    'Giờ': FieldReportDeliveryExcel.Hour,
    'Phút': FieldReportDeliveryExcel.Minute,
    'Ngày': FieldReportDeliveryExcel.Day,
    'Tháng': FieldReportDeliveryExcel.Month,
    'Năm': FieldReportDeliveryExcel.Year,
    'Ghi chú': FieldReportDeliveryExcel.Note
}
export const PAGE_SIZE_OPTIONS = ["10","20","30","40","50","100"]
export const LIMIT_PAGE_DEFAULT = 10
export const FORMAT_NUMBER_EXCEL = "#,###;-#,###;0";
